import { registerComponent } from './components-front'

registerComponent('event-enquiry-form', _ => {
    document.querySelectorAll('[data-type=ComponentEventEnquiryForm]').forEach(comp => {
        comp.querySelectorAll('[required][placeholder]').forEach(input => {
            input.setAttribute('placeholder', input.getAttribute('placeholder') + ' *')
        })
    })
})
